import { create } from 'zustand';
import service from "../api/FetchInterceptor";

export const useUserStore = create((set, get) => ({
    user: null,
    isLoading: true,
    error: null,

    // Actions
    setUser: (user) => set({ user, isLoading: false }),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error, isLoading: false }),

    fetchCurrentUser: async () => {
        try {
            set({ isLoading: true, error: null });

            const response = await service({
                url: '/current-user',
                method: 'GET'
            });

            set({ user: response.user || response, isLoading: false });
            return response.user || response;
        } catch (error) {
            console.error('Erreur lors de la récupération de l\'utilisateur:', error);
            set({ error: error.message, isLoading: false, user: null });
            throw error;
        }
    },

    updateUser: (updates) => set((state) => ({
        user: { ...state.user, ...updates }
    })),

    switchProfile: async (code) => {
        const response = await service({
            url: `/switch-profile/${code}`,
            method: 'POST'
        });

        set({ user: response.user || response });
        return response.user || response;
    },

    reset: () => set({ user: null, isLoading: false, error: null }),
}));